.button {
  width: 100%;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: var(--core-metrics-spacing-200);
}

.description {
  margin: 0 0 var(--core-metrics-spacing-500);
}

.heading {
  margin: var(--core-metrics-spacing-200) 0 var(--core-metrics-spacing-100);
}
